import { gql } from '@apollo/client';

// You must define extensions to the client schema here in order for any types/values to be visible within the DevTools
const typeDefs = gql`
  extend type Query {
    myNumber: Int!
  }
`;

export default typeDefs;
